import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  container: {
    borderRadius: '0 0 12px 12px'
  }
})
